// ABOUTME: Context and hook for the PWA update state (available, updating, version, trigger)
// ABOUTME: The provider lives in UpdateProvider.tsx; this file has no components

import { createContext, useContext } from "react"

export interface UpdateContextType {
  isUpdateAvailable: boolean
  isUpdating: boolean
  currentVersion: string
  triggerUpdate: () => Promise<void>
}

export const UpdateContext = createContext<UpdateContextType | null>(null)

export const useUpdateContext = () => {
  const context = useContext(UpdateContext)
  if (!context) {
    throw new Error("useUpdateContext must be used within UpdateProvider")
  }
  return context
}
